import dashboardAdmin, { dashboardAdminV2 } from "./dashboardadmin";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = dashboardAdmin;
export const menuItemsV2 = dashboardAdminV2;

export default menuItems;